module.exports = __webpack_public_path__ + "static/favicon-b9a0aa9d396f48f7267812498cc83bad.ico";